import { calculateProgress } from "../pages/Home/functions/projectCardFunctions";

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

/**
 * Trouve le breakpoint adapté à ceux définis dans tailwind.config.js
 * en fonction de la taille de l'écran.
 *
 * @param windowSize number La taille de l'écran
 */
export const getBreakPoint = (windowSize) => {
    let currentBreakpoint = "";

    if (windowSize < 640) {
        currentBreakpoint = "sm-"; // mobile petit écran
    } else if (windowSize >= 640 && windowSize < 768) {
        currentBreakpoint = "sm"; // mobile
    } else if (windowSize >= 768 && windowSize < 1024) {
        currentBreakpoint = "md"; // tablette
    } else if (windowSize >= 1024 && windowSize < 1234) {
        currentBreakpoint = "lg"; // PC
    } else if (windowSize >= 1234) {
        currentBreakpoint = "xl"; // PC avec écran beaucoup trop large pour un site internet :)
    } else {
        currentBreakpoint = "nique ta mère"; // cas par défaut
    }

    return currentBreakpoint;
}

export const formatDate = (dateString, withHours = false) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let formattedDate = `${day}/${month}`;

    if (withHours) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        formattedDate += ` à ${hours}:${minutes}`;
    } else {
        formattedDate += `/${year}`;
    }

    return formattedDate;
};

export const formatDatasProject = (project) => {
    return {
        ...project,
        DebutCollecte: formatDate(project.DebutCollecte.date),
        FinCollecte: formatDate(project.FinCollecte.date),
        DebutCollecteWithHours: formatDate(project.DebutCollecte.date, true),
        FinCollecteWithHours: formatDate(project.FinCollecte.date, true),
        MontantRecolte: parseFloat(project.MontantRecolte) || 0,
        MontantRecherche: parseFloat(project.MontantRecherche) || 1,
    }
}

export function sortProjectsByFundingAndDate(projects) {
    const notFullyFunded = [];
    const fullyFunded = [];

    projects.forEach(project => {
        const montantRecolte = parseFloat(project.MontantRecolte);
        const montantRecherche = parseFloat(project.MontantRecherche);

        if (montantRecolte < montantRecherche) {
            notFullyFunded.push(project);
        } else {
            fullyFunded.push(project);
        }
    });

    // On trie les projets non entièrement financés par numéro de projet décroissant
    notFullyFunded.sort((a, b) => {
        return parseInt(b.Position) - parseInt(a.Position);
    });

    // On trie les projets entièrement financés par date de début de collecte décroissante
    fullyFunded.sort((a, b) => {
        const dateA = new Date(
            a.DebutCollecte.split('/')
                .reverse() // Convertit le format DD/MM/YYYY en YYYY-MM-DD pour la construction de l'objet Date
                .join('-')
        );
        const dateB = new Date(b.DebutCollecte.split('/').reverse().join('-'));
        return dateB - dateA;
    });

    return [...notFullyFunded, ...fullyFunded];
}


// Fonction de formatage de chiffres pour l'affichage des gros montant en €.
// Ex: 2529 -> 2 K€, 23643931 -> 23 M€
export const formatAmount = (val) => {
    const num = parseInt(val, 10);
    if (isNaN(num)) return "0 €";
    if (num >= 1000000) {
        return `${(num / 1000000).toFixed().replace('.', ',')} M€`;
    }
    if (num >= 1000) {
        return `${(num / 1000).toFixed().replace('.', ',')} K€`;
    }
    return `${num} €`;
};